import { FeatureFlagKey } from '@/features/feature-flags/presentation/types/feature-flag-key';
import { Configuration } from './types';

/**
 * Internal UAT environment configuration.
 * This points at the UAT environment (i.e. all services referenced below are running/hosted in the UAT environment).
 */
export const config: Partial<Configuration> = {
  portalApi: 'https://ewa.api.uat.portal.genvis.com/v1',
  portalEwaBffApi: 'https://api.uat.portal.genvis.com/ewa/v1',
  mapbox: {
    overlaysTileSet: 'mapbox://robgenvis.ewa-overlays-dev',
    overlayTileSetLayers: {
      dfesRegions: 'dfes-regions-tileset-layer-dev',
      lga: 'lga-tileset-layer-dev',
      lgaCentres: 'lga-centres-tileset-layer-dev',
      pastoralStations: 'pastoral-stations-tileset-layer-dev',
    },
  },
  remoteHazardAssets: {
    iconAssetsPathSvg: 'https://uat.kudo.genvis.com/assets/icons/map/pins',
    iconAssetsPathPng: 'https://uat.kudo.genvis.com/assets/icons/map/pins/40x40',
  },
  geospatialBucket: 'https://d19wxpgkc9zeiw.cloudfront.net',
  windTileBaseUrl: 'https://d2z2pbo9svc3uc.cloudfront.net',
  externalTileBaseUrl: 'https://d3omvwfvh6ddq9.cloudfront.net',
  webTemplateStyleSheetUrl: 'https://uat.kudo.genvis.com/assets/styles/ewa-webtemplate.css',
  environment: 'uat',
  featureFlags: {
    [FeatureFlagKey.EnableMyEmergencyPlan]: true,
  },
  firebaseConfig: {
    apiKey: 'AIzaSyC6A0FVzT6BAvmlwh1pu8DVJ1lB_iirM6o',
    authDomain: 'ewa-web-uat.firebaseapp.com',
    projectId: 'ewa-web-uat',
    storageBucket: 'ewa-web-uat.firebasestorage.app',
    messagingSenderId: '174200265375',
    appId: '1:174200265375:web:cb416f8657c267300ee0aa',
    measurementId: 'G-DKXM3YFRCC',
  },
  recaptcha: {
    siteKey: '6Lf93LwrAAAAAAFjvssVV9Dg17LXJpzzSQavQstr',
    enabled: true,
  },
  sentry: {
    dsn: 'https://2946dfe99e66df21f5f92a4655a0b647@o4507253793816576.ingest.de.sentry.io/4507255077339216',
    enabled: true,
  },
};
